import ajax from "@/libs/Ajax";

// 后台命名空间
const NAME_SPACE = "/sys/notice";

export default {
  doQuery(params) {
    return ajax.get(`${NAME_SPACE}/queryNotice`, {params})
  },
  doGet(uuid) {
    return ajax.get(`${NAME_SPACE}/get/${uuid}`)
  },
  doDelete(uuid) {
    return ajax.delete(`${NAME_SPACE}/delete/${uuid}`)
  },
  doSave(data) {
    return ajax.post(`${NAME_SPACE}/save`, data)
  },
  getUserList() {
    return ajax.get(`${NAME_SPACE}/getUserList`);
  }
};